module.exports = __webpack_public_path__ + "img/content_3.773ec4e0.jpg";